<div class="press-details-wrapper" [class.arebic-content]="textDirection === 'rtl'">
  <section class="board-section">
    <div class="board-title">
      <h4 translate>SHARIA_BOARD.SHARIA_BOARD_TITLE</h4>
      <p translate class="title-contnet">SHARIA_BOARD.SHARIA_BOARD_CONTENT</p>
      <p translate>SHARIA_BOARD.SHARIA_BOARD_FEATURE</p>
      <ul>
        <li translate>SHARIA_BOARD.SHARIA_BOARD_FEATURE_1</li>
        <li translate>SHARIA_BOARD.SHARIA_BOARD_FEATURE_2</li>
        <li translate>SHARIA_BOARD.SHARIA_BOARD_FEATURE_3</li>
        <li translate>SHARIA_BOARD.SHARIA_BOARD_FEATURE_4</li>
      </ul>
      <p translate>SHARIA_BOARD.TALY_PRINCIPLES</p>
    </div>
    <h3 class="board-member-name" translate>SHARIA_BOARD.SUPER_VISOR</h3>

    <div class="board-grid supervisory">
      <div class="board-card">
        <img src="assets/images/board-member-2.svg" alt="Chairman" />
        <div class="card-info">
          <div class="role" translate>SHARIA_BOARD.CHAIRMAN</div>
          <div class="name" translate>SHARIA_BOARD.CHAIRMAN_NAME</div>
        </div>
      </div>
    </div>
    <div class="board-grid members">
      <div class="board-card">
        <img src="assets/images/board-member-3.svg" alt="Board Member" />
        <div class="card-info">
          <span class="role" translate>SHARIA_BOARD.BOARD_MEMBER</span>
          <div class="name" translate>SHARIA_BOARD.BOARD_MEMBER_1</div>
        </div>
      </div>

      <div class="board-card">
        <img src="assets/images/board-member-1.svg" alt="Board Member" />
        <div class="card-info">
          <span class="role" translate>SHARIA_BOARD.BOARD_MEMBER</span>
          <div class="name" translate>SHARIA_BOARD.BOARD_MEMBER_2</div>
        </div>
      </div>
    </div>
  </section>
</div>
